import { apiProvider } from './api';
import { router } from './router';
import Select from './components/Select.vue';
import { NAME } from './constants';

export const VozidloPujcovna = {
	name: NAME,
	apiProvider,
	router,
	components: {
		Select,
	},
};
